module.exports = __webpack_public_path__ + "img/img-9.a3510736.png";